import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { HideToastMessage, ShowToastMessage } from "../../redux/actions";
import "./ToastMessage.css";

export default function ToastMessage() {
  const dispatch = useDispatch();
  // const [isToastVisible, setIsToastVisible] = useState(false);
  const { isToastMessageVisible, toastMessage } = useSelector(
    (state) => state.appCommon
  );
  // ✅ Listen to global event from axios interceptor
  useEffect(() => {
    const handleSessionExpired = (event) => {
      dispatch(ShowToastMessage(event.detail)); // show toast
    };

    window.addEventListener("sessionExpired", handleSessionExpired);

    return () => {
      window.removeEventListener("sessionExpired", handleSessionExpired);
    };
  }, [dispatch]);
  useEffect(() => {
    if (isToastMessageVisible) {
      setTimeout(() => {
        // setIsToastVisible(false);
        dispatch(HideToastMessage());
      }, 5000);
    }
  }, [isToastMessageVisible]);
  if (!isToastMessageVisible) return;
  return (
    <div
      className="toast-message-container">
      <div className="toast-message-text">{toastMessage}</div>
    </div>
  );
}
